(function ($) {
  $(document).ready(function () {
    // Defining a function to hide unavailable products.
    window.hideUnavailable = function () {
      // Creating an instance of URLSearchParams to easily access URL parameters.
      var urlParams = new URLSearchParams(window.location.search);

      // Initializing an empty object to store the filter options extracted from the URL parameters.
      var filterOptions = {};

      // Iterating over each pair of parameters in the URL.
      for (var pair of urlParams.entries()) {
        // Checking if the key of the parameter pair starts with 'filter.v.option.'.
        if (pair[0].startsWith("filter.v.option.")) {
            // Extracting the filter name from the key.
            var filterName = pair[0].split(".").pop();

            // If the filter name already exists in the object, append to its array.
            if (filterOptions.hasOwnProperty(filterName)) {
                filterOptions[filterName].push(pair[1]);
            } else {
                // Otherwise, create a new array with the value.
                filterOptions[filterName] = [pair[1]];
            }
        }
    }

      // Mapping the 'size' property to 'option1'.
      filterOptions.option1 = filterOptions.size;

      // Removing the 'size' property from the filter options.
      delete filterOptions.size;

      // Iterating over each element with the class 'product'.
      $(".product").each(function () {
        // Setting the active product to the current element in the iteration.
        window.activeProduct = $(this);

        // Retrieving the 'data-variants' attribute of the active product.
        var dataVariants = window.activeProduct.attr("data-variants");

        // If 'data-variants' attribute exists, proceed to process it.
        if (dataVariants) {
          try {
            // Parsing the JSON formatted data-variants attribute.
            dataVariants = JSON.parse(dataVariants);
          } catch (e) {
            // Logging an error message in case of JSON parsing failure and exiting the function.
            console.error(e);
            return;
          }

          // If the URL contains 'filter', proceed to filter the products based on the options.
          if (window.location.search.includes("filter")) {
            let match;
            let shouldBreak = false;

            // Iterating over each variant in the data-variants array.
            for (let i = 0; i < dataVariants.length; i++) {
              let variant = dataVariants[i];

              // Checking if any filter option matches with the variant properties.
              for (var key in filterOptions) {
                if (
                  filterOptions[key].includes(variant[key]) &&
                  variant.available == true
                ) {
                  // If a match is found, setting match to true and breaking the loop.
                  match = true;
                  shouldBreak = true;
                  break;
                } else {
                  // If no match found, setting match to false.
                  match = false;
                }
              }

              // Breaking the outer loop if a match was found in the inner loop.
              if (shouldBreak) {
                break;
              }
            }

            // Showing the active product if a match was found, else hiding it.
            if (match) {
              window.activeProduct.show();
            } else {
              window.activeProduct.hide();
            }
          }
        }
      });
    };

    // Calling the hideUnavailable function when the document is ready.
    window.hideUnavailable();
  });
})(jQuery);
